document.addEventListener(
  'change',
  (event) => {
    if (!event.target.matches('.variant-option-drawer__options input[type="radio"]')) return;

    const dialogEl = event.target.closest('dialog');
    const trigger = dialogEl?.id
      ? document.querySelector(`[aria-controls="${dialogEl.id}"]`)
      : null;

    trigger?.classList.add('variant-option__drawer-trigger--loading');

    const dialogComponent = event.target.closest('dialog-component');
    if (typeof dialogComponent?.closeDialog === 'function') {
      dialogComponent.closeDialog();
    } else {
      dialogEl?.close();
    }
  },
  { passive: true }
);
